import { Snippet } from '#components/patterns/code/snippet/Snippet.tsx';
import type { DesktopOSName } from '#dn-types/downloads.ts';
import type { HostNoun } from '#dn-types/host.ts';
import type { EnrollmentState } from '../../types.ts';
import type { LinuxInstallMethod } from '../package-install.ts';
import { buildEnrollCommand } from './build-enroll-command.ts';
import { CondenseButton } from './CondenseButton.tsx';
import { TokenStatus } from './TokenStatus.tsx';

type Props = {
  hostNoun: HostNoun;
  enrollmentState: EnrollmentState;
  platform: DesktopOSName;
  installMethod?: LinuxInstallMethod;
  onCollapse?: () => void;
};

export function TokenInstructions({ hostNoun, enrollmentState, platform, installMethod, onCollapse }: Props) {
  const { token, isExpired, enrollSuccessful, handleDone } = enrollmentState;

  if (!token) {
    return <p className="p-md mb-24">Getting enrollment code…</p>;
  }

  return (
    <>
      <p className="p-md mb-24">
        In a {platform === 'Windows' ? 'PowerShell terminal run as administrator' : 'terminal'}, run the following
        command to enroll the {hostNoun}.
      </p>
      <Snippet
        disabled={isExpired}
        breakWord={true}
        secondaryButton={onCollapse && <CondenseButton onClick={onCollapse} />}
      >
        {buildEnrollCommand(platform, token, installMethod)}
      </Snippet>
      <TokenStatus hostNoun={hostNoun} enrollSuccessful={enrollSuccessful} handleDone={handleDone} />
    </>
  );
}
